import type { Middleware } from "redux";

import industryOptInMiddleware from "./industryOptInMiddleware";
import siActionsMiddleware from "./siActionsMiddleware";
import siAllTrackersMiddleware from "./siAllTrackersMiddleware";

const siMiddlewares: Middleware[] = [siAllTrackersMiddleware, siActionsMiddleware, industryOptInMiddleware];

export default siMiddlewares;
